import { Check, Sparkles, TrendingDown } from 'lucide-react';

export default function Pricing() {
  const inclusions = [
    "20 ساعة تدريبية مكثفة (تطبيق مباشر)",
    "تجربة العميل المحاكى (Simulated Client)",
    "مشروع بورتفوليو احترافي متكامل",
    "قالب دليل الهوية البصرية (Brand Guidelines)"
  ];

  return (
    <section id="pricing" className="py-32 relative overflow-hidden bg-slate-50 dark:bg-zinc-950 transition-colors duration-500 border-t border-slate-200 dark:border-white/5" dir="rtl">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#e00000] rounded-full w-[500px] h-[500px] blur-[150px] opacity-10 dark:opacity-20 pointer-events-none transition-all duration-500"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-lg font-bold text-[#e00000] dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2">
            <span className="w-8 h-1 bg-[#e00000] rounded-full"></span>
            استثمارك في الدورة
            <span className="w-8 h-1 bg-[#e00000] rounded-full"></span>
          </h2>
          <h3 className="text-4xl md:text-6xl font-extrabold text-slate-900 dark:text-white mb-6 leading-tight transition-colors duration-500">
            حوّل شغفك إلى <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 to-primary-700 dark:from-primary-400 dark:to-primary-600">مهنة مربحة</span>
          </h3>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Urgency Badge */}
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 z-20 bg-primary-600 text-white px-8 py-3 rounded-2xl font-extrabold text-lg shadow-xl animate-bounce flex items-center gap-2">
              <Sparkles className="w-5 h-5" />
              <span>متبقي مقاعد محدودة!</span>
            </div>

            <div className="bg-white/70 dark:bg-zinc-900/40 backdrop-blur-3xl border border-slate-200 dark:border-white/10 rounded-[3rem] p-8 md:p-16 shadow-2xl relative overflow-hidden group">
              {/* Inner Glow */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#e00000]/10 rounded-full blur-3xl -mr-32 -mt-32 transition-transform duration-700 group-hover:scale-110"></div>

              <div className="grid lg:grid-cols-2 gap-12 items-center relative z-10">
                {/* Left Side (Visual Price) */}
                <div className="text-center lg:text-right border-l-0 lg:border-l border-slate-200 dark:border-white/10 lg:pl-12 pb-12 lg:pb-0">
                  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-50 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 font-bold text-lg mb-6">
                    <TrendingDown className="w-4 h-4" />
                    <span>خصم خاص لأول 5 مسجلين فقط!</span>
                  </div>

                  <div className="flex items-center justify-center lg:justify-start gap-6 mb-8">
                    <div className="relative">
                      <span className="text-7xl md:text-9xl font-extrabold text-slate-900 dark:text-white drop-shadow-[0_0_20px_rgba(224,0,0,0.3)] dark:drop-shadow-[0_0_40px_rgba(224,0,0,0.5)]">
                        40<span className="text-4xl md:text-5xl ml-2">$</span>
                      </span>
                      {/* Red underline effect */}
                      <div className="h-4 w-full bg-[#e00000]/20 absolute -bottom-2 -rotate-2 -z-10 blur-sm"></div>
                    </div>

                    <div className="flex flex-col items-center">
                      <span className="text-3xl md:text-4xl font-bold text-slate-500 dark:text-zinc-500 line-through decoration-[#e00000] decoration-4">
                        50$
                      </span>
                      <span className="text-md font-bold text-slate-400 dark:text-zinc-600 uppercase mt-2 tracking-widest">السعر الأصلي</span>
                    </div>
                  </div>

                  <div className="flex flex-col gap-4 w-full">
                    <a href="#register" className="w-full flex items-center justify-center gap-4 bg-primary-600 hover:bg-primary-500 text-white px-10 py-6 rounded-2xl font-extrabold text-2xl transition-all duration-300 shadow-[0_0_30px_rgba(224,0,0,0.4)] hover:shadow-[0_0_50px_rgba(224,0,0,0.6)] hover:-translate-y-1">
                      احجز مقعدك الآن
                    </a>


                  </div>
                </div>

                {/* Right Side (List) */}
                <div>
                  <h4 className="text-2xl font-bold text-slate-900 dark:text-white mb-8">ماذا ستحصل عليه:</h4>
                  <ul className="space-y-6">
                    {inclusions.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-4 group/item">
                        <div className="w-8 h-8 rounded-full bg-green-50 dark:bg-green-500/10 border border-green-200 dark:border-green-500/20 flex items-center justify-center shrink-0 group-hover/item:bg-green-500 group-hover/item:text-white transition-all">
                          <Check className="w-5 h-5 text-green-600 dark:text-green-500 group-hover/item:text-white" />
                        </div>
                        <span className="text-lg md:text-xl text-slate-600 dark:text-zinc-300 font-medium">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
